module.exports = __webpack_public_path__ + "img/OA.9045bb73.jpg";